import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  > div {
    margin-bottom: 1rem;
  }

  > p {
    margin-bottom: 2rem;
  }

  p.Mui-error {
    margin-top: 0;
  }
  
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
`
